import { createStore } from "vuex";

const defaultSiteConfig = {
  servicePhone: "400-XXX-XXXX",
  serviceEmail: "service@icka.cn",
  workTime: "工作日 9:00-18:00",
  copyright: "Copyright © 2026 电子口岸IC卡 · All Rights Reserved",
  icpNumber: "沪ICP备XXXXXXXX号-1",
  privacyPolicyUrl: "",
  termsUrl: "",
};

export default createStore({
  state: {
    loadingState: false,
    siteConfig: { ...defaultSiteConfig },
  },
  getters: {
    getLoadingState(state) {
      return state.loadingState;
    },
    getSiteConfig(state) {
      return state.siteConfig;
    },
  },
  mutations: {
    setLoadingState(state, payload) {
      state.loadingState = payload;
    },
    setSiteConfig(state, payload) {
      state.siteConfig = {
        ...defaultSiteConfig,
        ...payload,
      };
    },
  },
  actions: {},
  modules: {},
});
